import { PDFDocument, rgb, StandardFonts } from "pdf-lib";

export const generateDealPDF = async (deal, autoDownload = true) => {
  try {
    // 1️⃣ Load template image
    const imageUrl = "/deal-template.jpg"; // in public folder
    const response = await fetch(imageUrl);

    if (!response.ok) {
      throw new Error("Failed to load template image");
    }

    const imgBytes = await response.arrayBuffer();

    // 2️⃣ Create PDF
    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage([595, 842]); // A4
    const { height } = page.getSize();

    // 3️⃣ Embed image
    let image;
    const firstByte = new Uint8Array(imgBytes)[0];
    image =
      firstByte === 0xff
        ? await pdfDoc.embedJpg(imgBytes)
        : await pdfDoc.embedPng(imgBytes);

    page.drawImage(image, {
      x: 0,
      y: 0,
      width: 595,
      height: 842,
    });

    // 4️⃣ Fonts
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

    const formatDate = (dateStr) => {
      const date = new Date(dateStr);
      const day = String(date.getDate()).padStart(2, "0");
      const month = date.toLocaleString("en-US", { month: "short" });
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    // 5️⃣ Draw text (same positions you already use)
    page.drawText(formatDate(deal.date), {
      x: 430,
      y: height - 250,
      size: 10,
      font: boldFont,
      color: rgb(0, 0, 0),
    });

    page.drawText(deal.buyer || "", {
      x: 300,
      y: height - 280,
      size: 13,
      font: boldFont,
      color: rgb(83 / 255, 177 / 255, 199 / 255),
    });

    page.drawText(deal.seller || "", {
      x: 300,
      y: height - 300,
      size: 13,
      font: boldFont,
      color: rgb(83 / 255, 177 / 255, 199 / 255),
    });

    page.drawText(deal.station || "", {
      x: 300,
      y: height - 324,
      size: 13,
      font,
    });

    page.drawText(deal.candy_rate || "", {
      x: 300,
      y: height - 347,
      size: 13,
      font: boldFont,
      color: rgb(83 / 255, 177 / 255, 199 / 255),
    });

    page.drawText(String(deal.bales || ""), {
      x: 300,
      y: height - 374,
      size: 13,
      font,
    });

    page.drawText(deal.quality || "", {
      x: 300,
      y: height - 407,
      size: 13,
      font,
    });

    page.drawText(deal.sauda || "", {
      x: 300,
      y: height - 442,
      size: 13,
      font,
    });

    page.drawText(deal.deal_period || "", {
      x: 300,
      y: height - 467,
      size: 13,
      font,
    });

    page.drawText(deal.terms || "", {
      x: 300,
      y: height - 493,
      size: 13,
      font,
    });

    page.drawText(deal.remarks || "", {
      x: 300,
      y: height - 520,
      size: 13,
      font,
    });

    // 6️⃣ Save PDF
    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    if (autoDownload) {
      const link = document.createElement("a");
      link.href = url;
      link.download = `deal_${deal.id || Date.now()}.pdf`;
      link.click();
    }

    return url; // 👈 used for VIEW
  } catch (err) {
    console.error("PDF Error:", err);
    alert("Failed to generate receipt");
  }
};
